/**
 * "404" as a character grid, in the same shape as the generated portrait so both
 * can go through <AsciiArt>.
 *
 * Drawn by hand rather than generated: the digits are geometry, not a
 * photograph, and there is no source image to sample. Vertical strokes are three
 * cells wide and horizontals two cells tall — in a monospace cell, which is
 * roughly 0.6 as wide as it is tall, that lands both strokes at about the same
 * visual weight. Cells on an edge step down the ramp so the mark falls off the
 * way the portrait's tones do instead of reading as a flat stencil.
 */
export const asciiNotFound = {
  cols: 35,
  rows: 12,
  ramp: ' .:-=+*#%@',
  cells:
    '      #%#     #%%%%%%#          #%#' +
    '     #@@%    #@@%%%%@@#        #@@%' +
    '    #@@@%    %@%    %@%       #@@@%' +
    '   #@%@@%    %@%    %@%      #@%@@%' +
    '  #@# %@%    %@%    %@%     #@# %@%' +
    ' #@#  %@%    %@%    %@%    #@#  %@%' +
    '#@%   %@%    %@%    %@%   #@%   %@%' +
    '%@@%%%@@%    %@%    %@%   %@@%%%@@%' +
    '#%%%%%@@%    %@%    %@%   #%%%%%@@%' +
    '      %@%    %@%    %@%         %@%' +
    '      %@%    #@@%%%%@@#         %@%' +
    '      #%#     #%%%%%%#          #%#',
};

export default asciiNotFound;
